// @ts-nocheck
import {
    getCanShowInventory,
    getIsSignedInAndhasToBeSignedIn,
    getSignInRequiredToAddToCartOrSeePrices,
    getWebsite,
    getWebsiteName,
} from "@store/Framework/Store/Context/ContextSelectors";

import { getIsAuthenticated } from "@store/Framework/Store/Foundation/Context/ContextSelectors";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";

export const useBunzlSettings = () => useSettingsCollection().bunzlSettings;

export const useWebsite = () => {
    return useAppSelector(state => getWebsite(state));
};

export const useWebsiteName = () => {
    return useAppSelector(state => getWebsiteName(state));
};

export const useGetSignInRequiredToAddToCartOrSeePrices = () => {
    return useAppSelector(state => getSignInRequiredToAddToCartOrSeePrices(state));
};

export const useIsAuthenticated = () => {
    return useAppSelector(state => getIsAuthenticated(state));
};

/**
 * **Never use this hook on a component initialization that calls an api**, because it can cause an infite reload issue.
 * Use useIsAuthenticated hook instead.
 *
 * @example Bad
 * const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();

    useEffect(() => {
        if (isSignedInAndhasToBeSignedIn) {
            loadCurrentAccount();
        }
    }, [isSignedInAndhasToBeSignedIn]);
 *
 *Good
 * const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
 *
 * if (!isSignedInAndhasToBeSignedIn) {
        return <SignInToSeePriceButton {...styles} />;
    }
 *
 * Good
 * const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        if (isAuthenticated) {
            loadCurrentAccount();
        }
    }, [isAuthenticated]);
 */
export const useIsSignedInAndhasToBeSignedIn = () => useAppSelector(state => getIsSignedInAndhasToBeSignedIn(state));

/**
 * Settings Hooks
 */

export const useDisplayProductPricesPolicy = () => useBunzlSettings()?.displayProductPricesPolicy;

export const useIsCreateAccountNeedApprobation = () => useBunzlSettings()?.enableCreateAccountNeedApprobation;

export const usePriceSpiderImplementationKey = () => useBunzlSettings()?.priceSpiderImplementationKey;

export const useCanShowInventory = () => useAppSelector(state => getCanShowInventory(state));

export const useIsHideSignInToSeePriceButton = () => useBunzlSettings()?.hideSignInToSeePriceButton;
